/**
 * Created by Darius on 2017.04.08.
 */
import React, {Component} from "react";
import {TextField, Toggle, SelectField, IconButton} from "material-ui";
import {blue500} from "material-ui/styles/colors";

const iconStyle = {
    color: blue500
};

const renderTextField = ({input, label, tooltip, type, meta: {touched, error}, ...custom}) => (

    <div style={{display: type == "hidden" ? "none" : "inline-block",width: 250,verticalAlign: "top"}}>
        <TextField type={type} style={{width: "calc(100% - 50px)"}} hintText={label} floatingLabelText={label}
                   errorText={touched && error} {...input} {...custom}/>
        {tooltip ? <IconButton iconClassName="material-icons" iconStyle={iconStyle} tooltipPosition="top-center" tooltip={tooltip}>info_outline</IconButton> : ""}
    </div>
);

const renderSwitchField = ({input, label, tooltip, type, meta: {touched, error}, ...custom}) => (

    <div style={{display: type == "hidden" ? "none" : "inline-block", width: 250}}>
        <Toggle label={label} toggled={input.value ? true : false}
                style={{
                    display: "inline-table",
                    width: "calc(100% - 50px)"
                }}
                onToggle={(event, isInputChecked) => {
                    let value = isInputChecked ? 1 : 0;
                    input.onChange(value);
                }}/>
        {tooltip ? <IconButton iconClassName="material-icons" iconStyle={iconStyle} tooltipPosition="top-center" tooltip={tooltip}>info_outline</IconButton> : ""}
    </div>
);

const renderSelectField = ({input, label, tooltip, children, meta: {touched, error}, ...custom}) => (

    <div style={{display: "inline-block", width: 250}}>
        <SelectField style={{width: "calc(100% - 50px)"}} hintText={label} floatingLabelText={label}
                     errorText={touched && error} {...input}
                     onChange={(event, index, value) => {
                         input.onChange(value);
                     }} {...custom}>
            {children}
        </SelectField>
        {tooltip ? <IconButton iconClassName="material-icons" iconStyle={iconStyle} tooltipPosition="top-center" tooltip={tooltip}>info_outline</IconButton> : ""}
    </div>
);

const renderTextAreaField = ({input, label, tooltip, type, meta: {touched, error}, ...custom}) => (

    <div style={{display: type == "hidden" ? "none" : "inline-block",width: 250}}>
        <TextField type={type} style={{width: "calc(100% - 50px)"}} hintText={label} floatingLabelText={label}
                   errorText={touched && error} {...input} {...custom} multiLine={true}/>
        {tooltip ? <IconButton iconClassName="material-icons" iconStyle={iconStyle} tooltipPosition="top-center" tooltip={tooltip}>info_outline</IconButton> : ""}
    </div>
);

export {renderTextField, renderSwitchField, renderSelectField, renderTextAreaField}